export default "__VITE_ASSET__BxMLnHjZ__"